// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/bulk_move_project_images.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/bulk_move_project_images.proto.
 */
export const file_vision_assets_v1_bulk_move_project_images: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vYXNzZXRzL3YxL2J1bGtfbW92ZV9wcm9qZWN0X2ltYWdlcy5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEisgEKHEJ1bGtNb3ZlUHJvamVjdEltYWdlc1JlcXVlc3QSTAoGcGFyYW1zGAEgASgLMjwucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuQnVsa01vdmVQcm9qZWN0SW1hZ2VzUmVxdWVzdC5QYXJhbXMaRAoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEQoJaW1hZ2VfaWRzGAIgAygJEhMKC2xvY2F0aW9uX2lkGAMgASgJIngKHUJ1bGtNb3ZlUHJvamVjdEltYWdlc1Jlc3BvbnNlEk0KBnJlc3VsdBgBIAEoCzI9LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkJ1bGtNb3ZlUHJvamVjdEltYWdlc1Jlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.assets.v1.BulkMoveProjectImagesRequest
 */
export type BulkMoveProjectImagesRequest = Message<"protos.vision.assets.v1.BulkMoveProjectImagesRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.BulkMoveProjectImagesRequest.Params params = 1;
   */
  params?: BulkMoveProjectImagesRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.BulkMoveProjectImagesRequest.
 * Use `create(BulkMoveProjectImagesRequestSchema)` to create a new message.
 */
export const BulkMoveProjectImagesRequestSchema: GenMessage<BulkMoveProjectImagesRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_bulk_move_project_images, 0);

/**
 * @generated from message protos.vision.assets.v1.BulkMoveProjectImagesRequest.Params
 */
export type BulkMoveProjectImagesRequest_Params = Message<"protos.vision.assets.v1.BulkMoveProjectImagesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: repeated string image_ids = 2;
   */
  imageIds: string[];

  /**
   * @generated from field: string location_id = 3;
   */
  locationId: string;
};

/**
 * Describes the message protos.vision.assets.v1.BulkMoveProjectImagesRequest.Params.
 * Use `create(BulkMoveProjectImagesRequest_ParamsSchema)` to create a new message.
 */
export const BulkMoveProjectImagesRequest_ParamsSchema: GenMessage<BulkMoveProjectImagesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_bulk_move_project_images, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.BulkMoveProjectImagesResponse
 */
export type BulkMoveProjectImagesResponse = Message<"protos.vision.assets.v1.BulkMoveProjectImagesResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.BulkMoveProjectImagesResponse.Result result = 1;
   */
  result?: BulkMoveProjectImagesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.BulkMoveProjectImagesResponse.
 * Use `create(BulkMoveProjectImagesResponseSchema)` to create a new message.
 */
export const BulkMoveProjectImagesResponseSchema: GenMessage<BulkMoveProjectImagesResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_bulk_move_project_images, 1);

/**
 * @generated from message protos.vision.assets.v1.BulkMoveProjectImagesResponse.Result
 */
export type BulkMoveProjectImagesResponse_Result = Message<"protos.vision.assets.v1.BulkMoveProjectImagesResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.BulkMoveProjectImagesResponse.Result.
 * Use `create(BulkMoveProjectImagesResponse_ResultSchema)` to create a new message.
 */
export const BulkMoveProjectImagesResponse_ResultSchema: GenMessage<BulkMoveProjectImagesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_bulk_move_project_images, 1, 0);

